export default "__VITE_ASSET__deMYPUmA__"